import React, { createContext, useEffect, useReducer } from 'react'
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";

const initialValue = {
    requests: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_SELLER_DATA': {
            return {
                ...state,
                seller_request: action.payload,
            }
        }
        case 'UPDATE_SELLER_DATA': {
            let newData = state.seller_request.requests.map((seller) =>
                action.payload.id === seller.id ? action.payload : seller
            );

            let newState = {
                requests: newData
            }

            return {
                ...state,
                seller_request: newState,
            }
        }
        default: {
            return state
        }
    }
}

const SellerRequestContext = createContext({
    seller_request: initialValue,
    getSellerRequests: () => {},
    paySeller: () => {},
})

export const SellerRequestProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)


    const getSellerRequests = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sellers/get_seller_requests', options);

            dispatch({
                type: 'LOAD_SELLER_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const paySeller = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/sellers/pay_seller', data, options);

            return res;
        } catch (e) {
            console.error(e)
            return e;
        }
    }

    useEffect(() => {
        getSellerRequests();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(state.seller_request === undefined) {
        return <MatxLoading />
    }

    return (
        <SellerRequestContext.Provider
            value={{
                seller_request: state.seller_request,
                getSellerRequests,
                paySeller,
            }}
        >
            {children}
        </SellerRequestContext.Provider>
    )
}

export default SellerRequestContext
